import { jsx as _jsx } from "react/jsx-runtime";
export function WhiteColumn(props) { return /*#__PURE__*/ _jsx("div", { style: { height: "100%", backgroundColor: props.backgroundColor || "white", display: "flex", flexDirection: "column", overflow: props.overflow }, children: props.children }); }
